import { ApiError } from "../../lib/api";
import { errorMessage } from "../../lib/errorMessage";

// Mark-paid sends the certificate e-mail before it records the payment. What
// nothing recorded looks like depends on why it failed, so the retry hint is
// only added where it is true.

/** Statuses that mean the e-mail may yet go out: letterman is down (503) or refused kartis's setup (502). */
const RETRYABLE = [502, 503];

/**
 * What to show reception when „Uhrazeno" failed. Only a failure that left
 * nothing behind — letterman unavailable or misconfigured — invites another
 * click; a certificate that is already paid or gone does not.
 */
export function markPaidFailed(err: unknown): string {
  const message = errorMessage(err, "Označení certifikátu selhalo.");
  if (err instanceof ApiError && RETRYABLE.includes(err.status)) {
    return `${message.replace(/\.$/, "")}. Nic se neuložilo, akci můžete zopakovat.`;
  }
  return message;
}

/** What to show a manager whose „Přeposlat e-mail" failed. */
export function resendFailed(err: unknown): string {
  return errorMessage(err, "Odeslání e-mailu se nezdařilo. Zkuste to znovu.");
}
